<!--
# Frontend Vue | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadFairSelectorModal
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
-->
<template>
  <div v-if="visible">
    <div class="modal d-block" tabindex="-1" role="dialog" @click.self="$emit('close')">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 rounded-4">
          <div class="modal-body px-4 pt-4 pb-3">
            <h2 class="h4 mb-3">{{ t('fairSelector.title') }}</h2>
            <div class="d-flex flex-column gap-2">
              <button
                v-for="fair in fairs"
                :key="fair.id"
                class="btn rounded-pill text-start"
                :class="selectedFairId === fair.id ? 'btn-primary' : 'btn-outline-secondary'"
                type="button"
                @click="$emit('select', fair.id)"
              >
                {{ fairDisplayLabel(fair.id) }}
                <span class="small opacity-75">({{ fair.count }} {{ t('list.leads') }})</span>
              </button>
            </div>
            <div class="mt-3 text-end">
              <button class="btn btn-outline-secondary rounded-pill" type="button" @click="$emit('close')">
                {{ t('fairSelector.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import { translateVisitorLead } from '@/components/visitor-lead/i18n.js'

const NO_FAIR_ID = 'OHNE_MESSE'

export default {
  name: 'VisitorLeadFairSelectorModal',
  props: {
    visible: { type: Boolean, default: false },
    fairs: { type: Array, default: () => [] },
    selectedFairId: { type: String, default: '' },
    locale: { type: String, default: 'en' },
  },
  methods: {
    t(key, replacements = {}) {
      return translateVisitorLead(key, replacements, this.locale)
    },
    fairDisplayLabel(fairId) {
      return fairId === NO_FAIR_ID ? this.t('scan.noFair') : fairId
    },
  },
}
</script>
